// frontend/src/pages/admin/adminWriteToken.ts — In-Memory-Store für den
// Admin-Write-Token.
//
// Warum In-Memory (kein localStorage / IndexedDB / Capacitor-Preferences):
// Der Token ist maximal ~1h gültig und wird beim Logout / Sperren sofort
// verworfen. Eine Persistenz über App-Restarts wäre ein Sicherheitsloch
// (gestohlene Token könnten nach einem App-Restart weiterverwendet werden).
// Phase-1-Garantie: der Token verlässt den Speicher NIE — er wird nur an
// den Server gesendet, und beim Tab-Verlassen / Logout gelöscht.

let token: string | null = null;

export function setAdminWriteToken(nextToken: string): void {
  if (typeof nextToken !== 'string' || !nextToken.trim()) return;
  token = nextToken.trim();
}

export function clearAdminWriteToken(): void {
  token = null;
}

export function getAdminWriteToken(): string | null {
  return token;
}

/**
 * Admin-Pfad-Praefixe, an die der Write-Token gesendet werden darf.
 *
 * W7-B: Die Admin-Operationen fuer Affiliates / Gutscheine / Promo-Codes und
 * der Rechnungs-Mailversand liegen NICHT unter `/api/admin`, sondern in eigenen
 * Routern (`server/affiliates.js`, `server/gift-codes.js`, `server/promo-codes.js`,
 * `server/invoices.js`). Sie haengen seit W7-B ebenfalls am `requireAdminWrite`-
 * Guard, brauchen also denselben Token — im Web ueber das Cookie (path '/api'),
 * in der nativen App ueber diesen Header.
 *
 * Jeder Eintrag endet bewusst auf '/': '/api/admin/' matcht NICHT
 * '/api/admin-export'.
 */
const ADMIN_WRITE_PATH_PREFIXES: readonly string[] = [
  '/api/admin/',
  '/api/coins/admin/',
  '/api/affiliates/admin/',
  '/api/gift-codes/admin/',
  '/api/promo/admin/',
  '/api/invoices/admin/',
];

/**
 * Setzt den `X-Admin-Write-Token`-Header, sofern:
 *  - ein Token gespeichert ist
 *  - der Ziel-Pfad eine Admin-Route aus ADMIN_WRITE_PATH_PREFIXES ist.
 *
 * Andere Endpoints sehen den Header NICHT — verhindert versehentliches
 * Mitschicken an Public-Endpoints.
 */
export function applyAdminWriteTokenHeader(headers: Headers, path: string): void {
  if (!token) return;
  if (!ADMIN_WRITE_PATH_PREFIXES.some((prefix) => path.startsWith(prefix))) return;
  try {
    headers.set('X-Admin-Write-Token', token);
  } catch {
    // Headers schreibgeschützt / Header-Wert ungültig — wir verschlucken still,
    // weil der Token nur eine "Best-Effort"-Freischaltung ist; der Server
    // antwortet ohne ihn ohnehin mit write_locked.
  }
}